export default __webpack_public_path__ + "static/media/foto-perfil-gabi.01dd14e7.png";